import $ from 'jquery'
import 'select2'

// import 'animate.css'

// window.addEventListener('DOMContentLoaded', () => {
//     console.log('DOMContentLoaded');
// })

var rootEl = document.documentElement;

var Select2Cascade = (function (window, $) {

    function Select2Cascade(parent, child, url, select2Options, emptySelectText, skintone_shades) {
        var afterActions = [];
        var options = select2Options || {};
        var emptySelectText = emptySelectText || '-- Select --';

        // Register functions to be called after cascading data loading done
        this.then = function (callback) {
            afterActions.push(callback);
            return this;
        };

        parent.select2(select2Options).on("change", function (e) {

            child.prop("disabled", true);
            var _this = this;

            $.getJSON(url.replace(':parentId:', $(this).val()), skintone_shades, function (items) {

                var newOptions = '<option value="">' + emptySelectText + '</option>';
                for (var id in items) {
                    newOptions += '<option value="' + id + '">' + items[id] + '</option>';
                }

                child.select2('destroy').html(newOptions).prop("disabled", false).select2(
                    {
                        // Sort results
                        // sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
                    }
                );

                afterActions.forEach(function (callback) {
                    callback(parent, child, items);
                });
            });
        });
    }

    return Select2Cascade;

})(window, $);

$(document).ready(function () {

    const bulmaCollapsibleInstances = bulmaCollapsible.attach('.is-collapsible');

    bulmaCollapsibleInstances.forEach(function ($el) {

        var instanceLink = document.querySelector("a[href='#" + $el.element.id + "']");

        $el.on('after:expand', (e) => {
            // console.log('After expand');
            // instanceLink.innerHTML = 'Show less <span class="icon"><i class="fas fa-angle-up" aria-hidden="true"></i></span>';
            instanceLink.remove();
        });

        $el.on('after:collapse', (e) => {
            // console.log('After collapse');
            instanceLink.innerHTML = 'Show more <span class="icon"><i class="fas fa-angle-down" aria-hidden="true"></i></span>';
        });
    });

    if ($('.result_list').length) {
        var infScroll = new InfiniteScroll('.result_list', {
            // options
            path: ".pagination__next",
            append: ".box",
            // append: ".page_box",
            history: false,
            hideNav: '.pagination',
            status: '.page-load-status'
        });
    }

    const shareButton = document.querySelector('.share-button');

    if (shareButton && navigator.share) {

        // Web Share API is supported
        shareButton.addEventListener('click', event => {

            event.preventDefault();

            if (navigator.share) {
                navigator.share({
                    title: 'Skintone set',
                    url: shareButton.dataset.link
                }).then(() => {
                    console.log('Thanks for sharing!');
                })
                    .catch(console.error);
            } else {
                // fallback
            }
        });
    } else {
        // Fallback
    }

    $('.js-shades').select2();

    var skintone_shades = (($('#selected_shade_selected_product').length) && {skintone_shades: true});

    var brandsOptions = {
        ajax: {
            url: '/api/v1/brands',
            dataType: 'json',
            data: function (params) {
                var query = {
                    search: params.term,
                    // ...(($('#selected_shade_selected_product').length) && {skintone_shades: true})
                    ...(skintone_shades)
                }
                return query;
            }
        }
    }

    var productsLoading = new Select2Cascade($('#brand'), $('#product'), '/api/v1/brands/:parentId:/products', brandsOptions, "-- Select product --", skintone_shades);
    var shadesLoading = new Select2Cascade($('#product'), $('#shade'), '/api/v1/products/:parentId:/shades', {}, "-- Select shade --", skintone_shades);

    productsLoading.then(function (parent, child, items) {
        //     // Dump response data
        //     console.log(items);
    });
    shadesLoading.then(function (parent, child, items) {
        //     // Dump response data
        //     console.log(items);
    });

    $("#shade").change(function () {
        $('.search_button').removeClass('hidden');
    });

    // $('.add').on('click', function () {
    //     $(this).find(".popup_input").css("display", "flex");
    // });

    // $('.store.add').on('click', function() {
    //     console.log("!");
    //     $(this).find(".add_store_modal").toggleClass("is-active");
    // });

    // $('.add_item').on('click', function (event) {
    //     event.preventDefault();
    //     $(this).parent('popup_input').hide();
    // });

    var rootEl = document.documentElement;
    var $modals = getAll('.modal');

    var $modalButtons = getAll('.modal-button');
    var $modalCloses = getAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button');

    if ($modalButtons.length > 0) {
        $modalButtons.forEach(function ($el) {
            $el.addEventListener('click', function () {
                var target = $el.dataset.target;
                openModal(target);
            });
        });
    }
    ;

    if ($modalCloses.length > 0) {
        $modalCloses.forEach(function ($el) {
            $el.addEventListener('click', function () {
                closeModals();
            });
        });
    }
    ;

    function getAll(selector) {
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
        return Array.prototype.slice.call(parent.querySelectorAll(selector), 0);
    }

    function openModal(target) {
        rootEl.classList.add('is-clipped');
        var $target = document.getElementById(target);
        $target.classList.add('is-active');
    }

    function closeModals() {
        rootEl.classList.remove('is-clipped');
        var $modals = getAll('.modal');
        $modals.forEach(function ($el) {
            $el.classList.remove('is-active');
        });
    }

    document.addEventListener('keydown', function (event) {
        var e = event || window.event;
        if (e.keyCode === 27) {
            closeModals();
            if (typeof closeDropdowns === 'function') closeDropdowns();
        }
    });

    init_filters_clicks();

    // var $brandFilterTags = getAll('.brand_filter');
    // var $product_types_tags = getAll('.product_type_filter');

    // var $searchResultBoxes = getAll('.result_list .box');

    // if ($product_types_tags.length > 0) {
    //     init_filters($product_types_tags, '.product_types_filter_selector', 'product-type')
    // }

    // if ($brandFilterTags.length > 0) {
    //     $brandFilterTags.forEach(function ($el) {
    //         $el.addEventListener('click', function () {
    //             $el.classList.toggle("is-loading");
    // console.log("!");
    // $('#results_section').addClass('is-loading');
    //
    //             var $selectedBrands = getAll('.brands_filter_selector .active');
    //             console.log($selectedBrands.length);
    //             var brand_ids = new Array();
    //
    //             $selectedBrands.forEach(function ($el) {
    //                 brand_ids.push($el.dataset.brand);
    //             });
    //
    //             console.log(brand_ids);
    //
    //             if ($selectedBrands.length == 0) {
    //                 $searchResultBoxes.forEach(function ($box) {
    //                     $box.classList.remove("is-hidden");
    //                 });
    //             } else {
    //                 $selectedBrands.forEach(function ($el) {
    //
    //                     $searchResultBoxes.forEach(function ($box) {
    //                         if (brand_ids.includes($box.dataset.brand)) {
    //                             $box.classList.remove("is-hidden");
    //                         } else {
    //                             $box.classList.add("is-hidden");
    //                         }
    //                         ;
    //                     });
    //                 });
    //             }
    //         });
    //     });
    // }
});

function init_filters_clicks() {
    // $('.filter_tag').each(function(index) {
    //     $(this).on("click", function(){
    //         $('#results_section').addClass('is-loading');
    //     });
    // });
}

function init_filters(filter_tags, selector, data_type) {

    var $searchResultBoxes = getAll('.result_list .box');

    filter_tags.forEach(function ($el) {
        $el.addEventListener('click', function () {
            $el.classList.toggle("active");

            console.log(selector);

            var $selectedTags = getAll(selector + ' .active');

            console.log($selectedTags.length);

            var tag_ids = new Array();

            $selectedTags.forEach(function ($el) {
                // data_type = $el.getAttribute('data-product-type');
                tag_ids.push($el.dataset.type);
            });

            console.log(tag_ids);

            if ($selectedTags.length == 0) {
                $searchResultBoxes.forEach(function ($box) {
                    $box.classList.remove("is-hidden");
                });
            } else {
                $selectedTags.forEach(function ($el) {

                    $searchResultBoxes.forEach(function ($box) {

                        // console.log($box.dataset(data_type));
                        // console.log(tag_ids);
                        // console.log($box.getAttribute('data-product-type'));
                        var data_type = $box.getAttribute('data-product-type');

                        if (tag_ids.includes(data_type)) {
                            $box.classList.remove("is-hidden");
                        } else {
                            $box.classList.add("is-hidden");
                        }
                        ;
                    });
                });
            }
        });
    });

}

